// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamListItemAboutSection-module--container--7ff385"};